import moment from "moment";

const VIEWED_ARTICLE_KEY = "viewed-articles";
const MAX_VIEWED_ARTICLE_LIFETIME_DAYS = 1;

export type ViewedArticleData = {
  id: number;
  dateViewed: string; // Store as ISO string for consistency
};

export function getViewedArticles(): ViewedArticleData[] {
  const storedJson = localStorage.getItem(VIEWED_ARTICLE_KEY);
  if (!storedJson) {
    return [];
  }

  let parsedJson: ViewedArticleData[] = JSON.parse(storedJson);

  if (!Array.isArray(parsedJson)) {
    localStorage.removeItem(VIEWED_ARTICLE_KEY);
    return [];
  }

  // Remove old viewed articles
  const cutoffDate = moment().subtract(
    MAX_VIEWED_ARTICLE_LIFETIME_DAYS,
    "days",
  );
  const validArticles = parsedJson.filter((entry) =>
    moment(entry.dateViewed).isAfter(cutoffDate),
  );

  // Refresh localStorage with valid articles only
  localStorage.setItem(VIEWED_ARTICLE_KEY, JSON.stringify(validArticles));

  return validArticles;
}

export function addViewedArticle(id: number) {
  const viewedArticles = getViewedArticles();

  if (!viewedArticles.some((entry) => entry.id === id)) {
    viewedArticles.push({ id, dateViewed: moment().toISOString() });
  }

  localStorage.setItem(VIEWED_ARTICLE_KEY, JSON.stringify(viewedArticles));
}

export function filterRecommendedArticles(
  articles: any[],
  currentArticleId: number,
) {
  const viewedArticles = getViewedArticles();
  const unviewedArticles = articles.filter(
    (article) =>
      article.id !== currentArticleId &&
      !viewedArticles.some((viewed) => viewed.id === article.id),
  );

  if (unviewedArticles.length > 0) {
    return unviewedArticles;
  }

  // If all articles are viewed, reset storage and start again
  localStorage.removeItem(VIEWED_ARTICLE_KEY);
  addViewedArticle(currentArticleId);
  return articles.filter((article) => article.id !== currentArticleId);
}
